import { resolveBackendUrl } from "../utils/runtimeConfig";

export const API = resolveBackendUrl(process.env.REACT_APP_API_URL || '/api');
export default API;
